// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__X2vpJ","social":"Footer_social__oorqV","center":"Footer_center__UZb9+"};